import { createMutation, createQuery } from 'react-query-kit';

import * as Types from '../api/purchase/types.api';
import * as API from '../api/purchase/index.api';
import { enqueueSnackbar } from 'notistack';

//
//

const key = 'purchase';

//

export const usePurchaseByIdGet = createQuery<Types.PurchaseByIdResponse, Types.PurchaseByIdQuery>({
  queryKey: [key],
  fetcher: (params) => API.getPurchaseByIdAPI(params),
});

//

export const usePurchaseBusinessCertificateGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'certificate'],
  mutationFn: (params) => API.getBusinessCertificateAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase certificate successfully downloaded!`, { variant: 'success' });
  },
});

//

export const usePurchaseCustomerCertificateGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'customer-certificate'],
  mutationFn: (params) => API.getCustomerCertificateAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase certificate successfully downloaded!`, {
      variant: 'success',
    });
  },
});

//

export const usePurchaseReceiptGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'receipt'],
  mutationFn: (params) => API.getReceiptAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase receipt successfully downloaded!`, { variant: 'success' });
  },
});

//

export { key as PURCHASE_QUERY_KEY };